export default (newPaymentFormData) => ({
  currency: newPaymentFormData?.currency,
  accountNumber: newPaymentFormData?.accountNumber?.trim() || null,
  sortCode: newPaymentFormData?.sortCode?.trim().replace(/-/g, '') || null,
  network: newPaymentFormData?.network || null
});
